// Google Analytics 4 (Firebase Analytics) wrapper.
//
// Every call is fire-and-forget and safe to make before analytics has
// resolved — or when it never does (unsupported browser, no measurement id).
// Analytics must never break a user flow, so failures are swallowed.

import {
  logEvent,
  setUserId,
  setUserProperties,
} from 'firebase/analytics';
import { analyticsPromise } from './firebase';

const withAnalytics = (fn) => {
  analyticsPromise
    .then((analytics) => {
      if (analytics) fn(analytics);
    })
    .catch(() => {});
};

export const trackEvent = (name, params) =>
  withAnalytics((analytics) => logEvent(analytics, name, params));

export const trackPageView = (path, title) =>
  withAnalytics((analytics) =>
    logEvent(analytics, 'page_view', {
      page_path: path,
      page_location: window.location.href,
      page_title: title ?? document.title,
    })
  );

// uid is hashed by GA on ingest; passing null detaches the current user.
export const trackUser = (uid, properties) =>
  withAnalytics((analytics) => {
    setUserId(analytics, uid);
    if (properties) setUserProperties(analytics, properties);
  });
